import { waitForElement } from "../utils";

class LiveChatContainer
{
    constructor(container: HTMLElement) {

        waitForElement('.LPMcontainer').then((elm) => {
            container.appendChild(elm);
        });
    }       
};

export { LiveChatContainer };
